import interact from 'interactjs';

export default  {
    methods: {
        getMountedFunctions: function(obj) {
            let props = [];

            do {
                props = props.concat(Object.getOwnPropertyNames(obj));
            } while (obj = Object.getPrototypeOf(obj));

            return props.sort().filter(function (e, i, arr) {
                return (e.startsWith('mounted'));
            });
        },
        tap: function() {
            this.$emit('input', this.index);
            $('html').css('cursor', 'auto');

            this.$nextTick(function () {
                EaseEventBus.fire('reinitializeDragula');
                EaseEventBus.fire('tap', {index: this.index});
            });

            $('input').blur();
        }
    },
    mounted() {
        _.forEach(this.getMountedFunctions(this), (value) => {
            this[value]();
        });

        EaseEventBus.listen('element.' + this.index + '.lock', () => {
            this.mountedIsResizable();
        });
    }
}
